import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Card, CardHeader, CardTitle, CardBody, ListGroup, ListGroupItem } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import config from '../../../../config';

import { getConversations, getConversationsByApplicant, getConversationOption, getConversationParticipantId, getConversationName, getUnreadMessagesCount, getUnreadMessages } from '../../ConversationActions';
import { getCurrentApplicant } from '../../../Applicant/ApplicantActions';
import { getLoggedUser } from '../../../User/UserActions';

import Conversation from '../conversation/Conversation';

class ConversationList extends Component {
	constructor(props) {
		super(props);

		this.state = {
			displayList: false,
			activeConversationsIds: [],
			openConversationId: null,
			maxConversationHeight: 0,
		};

		this.conversationReducedWidth = 300;
		this.conversationEnlargedWidth = 450;
		this.conversationReducedHeight = 40;

		this.conversationMaxCount = 5;
	}

	componentDidMount() {
		this.setDimensions();
		window.addEventListener('resize', this.setDimensions.bind(this));
	}

	componentDidUpdate(prevProps, prevState) {
		if(prevProps.currentApplicant !== this.props.currentApplicant) {
			// console.log(this.props.currentConversations, this.getActiveConversations());
		}
		// console.log('Conversation::: Ring new message?', getUnreadMessagesCount(prevProps.conversations.filter(conversation => !this.state.activeConversationsIds.includes(conversation._id)), this.props.user), getUnreadMessagesCount(this.props.conversations.filter(conversation => !this.state.activeConversationsIds.includes(conversation._id)), this.props.user));
		if(['student'].includes(this.props.user?.role) && this.props.conversations?.length && getUnreadMessagesCount(prevProps.conversations, this.props.user) < getUnreadMessagesCount(this.props.conversations, this.props.user)) {
			this.handleRing();
		}
	}

	setDimensions = () => {
		const width = window.innerWidth;
		const height = window.innerHeight;
		this.setState({
			maxConversationHeight: Math.round((height / 3) * 2),
		});
	};

	// 1 width for list + 1 width per active conversation
	getWrapperWidth() {
		return this.conversationReducedWidth + (this.state.activeConversationsIds.length * this.conversationReducedWidth) + (this.state.openConversationId ? this.conversationEnlargedWidth - this.conversationReducedWidth : 0);
	}

	getActiveConversations() {
		if((this.props.currentConversations || []).length) {
			return this.props.currentConversations;
		}
		return this.props.conversations.filter(conversation => conversation.participants.length > 1 && this.state.activeConversationsIds.includes(conversation._id));
	}

	handleRing() {
		if(document.getElementById('conversation-message-new-sound')) {
			document.getElementById('conversation-message-new-sound').play();
		}
	}

	handleOpenConversation(conversationToAdd) {
		let activeConversationsIds = this.state.activeConversationsIds.filter(conversationId => conversationId !== conversationToAdd._id);
		if(this.state.activeConversationsIds.length > this.conversationMaxCount) {
			activeConversationsIds = this.state.activeConversationsIds.slice(-this.conversationMaxCount);
		}
		this.setState({
			openConversationId: conversationToAdd._id,
			activeConversationsIds: [...activeConversationsIds, conversationToAdd._id],
			displayList: false,
		});
	}

	renderActiveConversations() {
		let displayNotification = false;
		const activeConversations = this.getActiveConversations().filter(conversation => conversation.participants.filter(participant => getConversationParticipantId(participant) !== this.props.user._id).length > 0 || (this.props.currentApplicant && (((conversation.target || {})._id || conversation.target) === this.props.currentApplicant._id))).map(conversation => {
			const unreadMessagesCount = getUnreadMessagesCount([conversation], this.props.user);
			displayNotification = displayNotification || unreadMessagesCount > 0;
			return (
				<div key={conversation._id} className="float-end" style={{ position: 'relative', width: `${this.state.openConversationId === conversation._id ? this.conversationEnlargedWidth : this.conversationReducedWidth}px`, height: `${this.conversationReducedHeight}px` }}>
					{
						this.state.openConversationId === conversation._id
							? (
								<div style={{ position: 'absolute', bottom: '0', left: '0', width: '100%' }}>
									<Conversation conversation={conversation} maxHeight={this.state.maxConversationHeight} reduceConversation={() => this.setState({ openConversationId: null })} closeConversation={!this.props.currentApplicant && (() => this.setState({ openConversationId: null, activeConversationsIds: this.state.activeConversationsIds.filter(activeConversationId => activeConversationId !== conversation._id) }))} />
								</div>
							) : (
								<div style={{ height: `${this.conversationReducedHeight}px`, lineHeight: `${this.conversationReducedHeight}px` }} className={`rounded-top bg-light shadow ${unreadMessagesCount ? 'bg-gradient-danger text-white font-weight-bolder blink' : ' text-gray-800 border-left-secondary'} text-center `} onClick={() => this.handleOpenConversation(conversation)}>
									{getConversationName(conversation, this.props.user) || <FormattedMessage id="conversation" defaultMessage="Conversation" />}{' '}{unreadMessagesCount > 0 && <strong>({unreadMessagesCount})</strong>}
								</div>
							)
					}
				</div>
			);
		});

		return (
			<div className="position-relative">
				{activeConversations}
				{displayNotification && !this.state.openConversationId && this.renderNotification()}
			</div>
		);
	}

	renderList() {
		const conversations = this.props.conversations.filter(conversation => conversation.participants.length > 1 && !getConversationOption(conversation, 'hideOnList'));
		if(conversations && conversations.length) {
			return (
				<div style={{ position: 'relative', width: `${this.state.displayList ? this.conversationReducedWidth : 50}px`, height: `${this.conversationReducedHeight}px` }} className="float-end">
					<div className="shadow" style={{ position: 'absolute', bottom: '0', left: '0', width: '100%' }}>
						{
							this.state.displayList
								? <ListGroup style={{ maxHeight: '300px', overflow: 'auto' }}>
									{conversations.map(conversation => (
										<ListGroupItem key={conversation._id} onClick={() => this.handleOpenConversation(conversation)} className="" style={{ overflow: 'hidden' }}>
											{getConversationName(conversation)}
										</ListGroupItem>
									))}
								</ListGroup>
								: null
						}
						<div style={{ height: `${this.conversationReducedHeight}px`, lineHeight: `${this.conversationReducedHeight}px` }} className="rounded-top bg-gradient-primary text-white text-lg text-center" onClick={event => this.setState({ displayList: !this.state.displayList })}>
							{this.state.displayList ? <span><FontAwesomeIcon icon="times-circle" fixedWidth /> <FormattedMessage id="conversationTitle" defaultMessage="Chat" /></span> : <FontAwesomeIcon icon="comments" fixedWidth />}
						</div>
					</div>
				</div>
			);
		}
	}

	renderNotification() {
		return (
			<div className="position-absolute w-50 display-1 text-center" style={{ bottom: '40px', right: '25%' }}>
				<svg className="conversation-notification" viewBox="0 0 16 16">
					<g className="conversation-notification-bell">
						<g>
							<path className="conversation-notification-clapper" d="M7 12C7.55228 12 8 12.4477 8 13C8 12.4477 8.44772 12 9 12C9.55228 12 10 12.4477 10 13C10 13.5272 9.81989 14.0443 9.43211 14.4321C9.04433 14.8199 8.52725 15 8 15C7.47275 15 6.95567 14.8199 6.56789 14.4321C6.18011 14.0443 6 13.5272 6 13C6 12.4477 6.44772 12 7 12Z" />
							<path d="M2 7C2 3.64772 4.64772 1 8 1C11.3523 1 14 3.64772 14 7V11C14.5523 11 15 11.4477 15 12C15 12.5523 14.5523 13 14 13H2C1.44772 13 1 12.5523 1 12C1 11.4477 1.44772 11 2 11V7ZM4 11H12V7C12 4.75228 10.2477 3 8 3C5.75228 3 4 4.75228 4 7V11Z" />
						</g>
						<circle className="conversation-notification-badge" cx="11" cy="3" r="3" />
						<circle cx="11" cy="3" r="3" />
					</g>
				</svg>
			</div>
		);
	}

	render() {
		if(this.props.user) {
			return (
				// Positioned from the stylesheet, so the layout can move it aside (attachment panel)
				// and keep it above the exam content: only the width depends on the open chats.
				<div className="conversation-dock" style={{ width: `${this.getWrapperWidth()}px` }}>
					{!this.props.currentApplicant && this.renderList()}
					{this.renderActiveConversations()}
					<div className="d-none">
						<audio id="conversation-message-new-sound" preload="auto" loop={false}>
							<source src={`${config.url}assets/audios/message-alert.mp3`} type="audio/mpeg" />
							<embed hidden src={`${config.url}assets/audios/message-alert.mp3`} />
						</audio>
					</div>
				</div>
			);
		}
		return null;
	}
}

function mapStateToProps(store, props) {
	const user = getLoggedUser(store);
	const currentApplicant = getCurrentApplicant(store);
	return {
		user,
		conversations: getConversations(store, user),
		currentApplicant,
		currentConversations: getConversationsByApplicant(store, currentApplicant),
	};
}

ConversationList.propTypes = {
	user: PropTypes.object,
	conversations: PropTypes.arrayOf(PropTypes.object),
	currentApplicant: PropTypes.object,
	currentConversations: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(ConversationList);
